import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const stats = [
  {
    value: "150+",
    label: "Projects Delivered",
    icon: "🚀",
    desc: "Across industries & domains",
    color: "from-blue-100 to-sky-50",
    border: "border-blue-200",
    badge: "bg-blue-100 text-blue-700",
  },
  {
    value: "4+",
    label: "Years Experience",
    icon: "⚡",
    desc: "Building digital products",
    color: "from-indigo-100 to-blue-50",
    border: "border-indigo-200",
    badge: "bg-indigo-100 text-indigo-700",
  },
  {
    value: "15+",
    label: "Industries Served",
    icon: "🌍",
    desc: "Global & Indian clients",
    color: "from-sky-100 to-blue-50",
    border: "border-sky-200",
    badge: "bg-sky-100 text-sky-700",
  },
  {
    value: "24/7",
    label: "Support Available",
    icon: "🛡️",
    desc: "Always here when you need us",
    color: "from-blue-100 to-indigo-50",
    border: "border-blue-200",
    badge: "bg-blue-100 text-blue-800",
  },
  {
    value: "18+",
    label: "Team Members",
    icon: "👨‍💻",
    desc: "Designers, developers & strategists",
    color: "from-cyan-100 to-sky-50",
    border: "border-cyan-200",
    badge: "bg-cyan-100 text-cyan-700",
  },
];

const tech = [
  "React",
  "Node.js",
  "Flutter",
  "Next.js",
  "WordPress",
  "Figma",
  "Premiere Pro",
  "Meta Ads",
  "Shopify",
  "Python",
  "UGC Video Editing",
  "Graphic Designing",
  "Logo Creation",
  "MERN Stack",
  "Content Creation",
  "AI Video Editing",
  "Motion Graphics",
];

export default function TrustSection() {
  const ref = useScrollAnimation();

  return (
    <>
     
<style>{`
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:wght@700;900&display=swap');

  .trust-num { font-family: 'Fraunces', serif; }
  .trust-body { font-family: 'Plus Jakarta Sans', sans-serif; }

  @keyframes marquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  .animate-marquee {
    display: flex;
    width: max-content;
    animation: marquee 12s linear infinite; /* smaller = faster */
  }
`}</style>

      <section
        id="trust"
        className="py-20 relative overflow-hidden bg-gradient-to-b from-blue-50 to-white"
      >
        {/* Top divider */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-300/60 to-transparent" />

        {/* Decorative blobs */}
        <div className="absolute -top-10 -left-10 w-64 h-64 bg-blue-100/60 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute top-10 right-0 w-48 h-48 bg-sky-100/50 rounded-full blur-2xl pointer-events-none" />

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* Section label */}
         <div className="text-center mb-10">
  <span className="trust-body inline-block text-sm font-bold text-blue-600 tracking-widest uppercase">
    -: Why Businesses Trust Us :-
  </span>
</div>

          {/* Stats Grid */}
          <div ref={ref} className="section-animate grid grid-cols-1 md:grid-cols-5 gap-5">
            {stats.map((s, i) => (
              <div
                key={i}
                className={`relative group bg-gradient-to-br ${s.color} border ${s.border} rounded p-6 md:p-8 text-center shadow-sm hover:shadow-blue-200/60 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 overflow-hidden`}
              >
                {/* Subtle inner glow on hover */}
                <div className="absolute inset-0 rounded-3xl bg-white/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

                {/* Icon badge */}
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-2xl ${s.badge} text-2xl mb-4 shadow-sm`}>
                  {s.icon}
                </div>

                {/* Number */}
                <div
                  className="trust-num font-black text-4xl md:text-5xl text-blue-700 mb-1 leading-none"
                  style={{ background: "linear-gradient(135deg, #1d4ed8, #0ea5e9)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}
                >
                  {s.value}
                </div>

                {/* Label */}
                <div className="trust-body font-bold text-black text-sm md:text-base mb-1">
                  {s.label}
                </div>

                {/* Sub desc */}
                <div className="trust-body text-slate-700 text-xs">
                  {s.desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Marquee tech strip */}
        <div className="mt-16 overflow-hidden border-y border-blue-100 bg-blue-50 py-4">
          <div className="flex animate-marquee whitespace-nowrap">
            {tech.map((t, i) => (
              <span
                key={i}
                className="trust-body mx-5 text-black text-sm font-semibold tracking-widest uppercase flex items-center gap-4"
              >
                {t}
                <span className="text-blue-200 mx-1">·</span>
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}